// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/campaigns-editor/campaigns-editor.component.scss
// module id = 178
// module chunks = 0